import { Component, Input, OnInit } from '@angular/core';
import { DateFormat } from '@app/core/types/date-format';
import { TranslateService } from '@ngx-translate/core';

interface LoginActivity {
  // TODO: move from here
  id: number;
  email: string;
  time: string;
  success: boolean;
}

@Component({
  selector: 'itfg-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: false,
})
export class WelcomeComponent implements OnInit {
  @Input() operator;
  @Input() loginHistory: LoginActivity[];
  @Input() loginHistoryFromDate: string;

  lastLogin: LoginActivity | null = null;
  failedAttemptsCount: Number = 0;
  dateFormat = DateFormat.TIME;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    if (this.loginHistory && this.loginHistory.length > 0) {
      this.lastLogin = this.loginHistory[0];
      this.failedAttemptsCount = this.loginHistory.filter(
        (login) => !login.success
      ).length;
    }
  }

  getGreeting(): string {
    const hour = new Date().getHours();
    if (hour < 10) {
      return this.translateService.instant('administrators.greetings.morning');
    }
    if (hour < 18) {
      return this.translateService.instant(
        'administrators.greetings.afternoon'
      );
    }

    return this.translateService.instant('administrators.greetings.evening');
  }
}
